import {ClientEntity} from "@common-core/coat-operational-hierarchy-appsync-model";
import {BoidAssignmentState, fromSubAccount} from "../model";

/**
 * This mapping function transforms each {@link SubAccount} from the
 * specified {@link ClientEntity} into a {@link BoidAssignmentState}
 * list.
 *
 * @param client The {@link ClientEntity} whose {@link SubAccount|SubAccounts}
 * are to be transformed into a {@link BoidAssignmentState} list.
 *
 * @see {@link ClientEntity}
 * @see {@link BoidAssignmentState}
 */
export const assignmentStatesFromClientEntity = (
  client: ClientEntity
): BoidAssignmentState[] => {
  return client?.subaccounts?.map(fromSubAccount(client.caId)) ?? [];
};
